export default __webpack_public_path__ + "static/media/slt3-min.360b704c.jpg";